import { Modal, Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { api_url } from "../../constant/constant";
import "./Lcusermodal.css";
import { useNavigate } from "react-router-dom";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { showToast } from "../ShowToast/ToastNotification";
import { NavLink } from "react-router-dom";

const LcUserModal = ({ LearningManager_id }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setLcUser] = useState([]);
  const [links, setLinks] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCheckboxChange = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedIds((prevSelectedIds) => [...prevSelectedIds, id]);
    } else {
      setSelectedIds((prevSelectedIds) =>
        prevSelectedIds.filter((selectedId) => selectedId !== id)
      );
    }
  };

  const handleAnswersClick = (id) => {
    navigate(`/question/${id}`);
  };

  const handleRemove = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/learning-campaigns-users/${LearningManager_id}/detach-users`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            user_ids: selectedIds,
          }),
        }
      );

      if (response.ok) {
        showToast(t("userDeletedSuccess"), "success");
        fetchLcUserModal(""); // Refresh the data
      } else {
        showToast(t("userDeleteFailed"), "error");
      }
    } catch (error) {
      showToast(t("somethingWentWrong"), "error");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchValue !== "") {
      const filteredData = data.filter(
        (item) =>
          item.email.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.username.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.firstname.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.lastname.toLowerCase().includes(searchValue.toLowerCase())
      );
      setLcUser(filteredData);
    } else {
      fetchLcUserModal(""); // Fetch data on page load
    }
  }, [searchValue]);

  const fetchLcUserModal = async (url) => {
    setLoading(true);
    let page = 1;
    if (url) {
      const temp = url.split("?page=");
      page = temp[1] || 1;
    }

    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(
        url ||
          `${api_url}/learning-campaigns-users/${LearningManager_id}/assigned-users?page=${page}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setLcUser(result.data.data || []);
      setLinks(result.data.links);
    } catch (error) {
      showToast(t("errorfetchingdata"), "error");
    } finally {
      setLoading(false);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "email",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-clipboard-data"></i>
            {t("Email")}
          </div>
        ),
        colName: t("Email"),
      },
      {
        accessorKey: "username",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-clipboard-data"></i>
            {t("UserName")}
          </div>
        ),
        colName: t("UserName"),
      },
      {
        accessorKey: "firstname",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-clipboard-data"></i>
            {t("FirstName")}
          </div>
        ),
        colName: t("FirstName"),
      },
      {
        accessorKey: "lastname",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-clipboard-data"></i>
            {t("LastName")}
          </div>
        ),
        colName: t("LastName"),
      },
      {
        accessorKey: "id",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src="/images/fi_alert-octagon.png" alt="Source" />
            {t("Action")}
          </div>
        ),
        cell: ({ getValue }) => {
          const id = getValue();
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <input
                type="checkbox"
                onChange={(e) => handleCheckboxChange(e, id)}
              />
            </div>
          );
        },
        colName: t("Action"),
      },
    ],
    []
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-4 mb-4">
      {/* Search and Add User Section */}
      <div className="primaryBlueBox mb-4" id="pa">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">{t("SearchUsers")}</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("Searchbyname")}
                aria-label="Search by name"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <button
                className="btn btn-outline-secondary btnSearchIcon"
                type="button"
              >
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
          <div className="col-md-1">
            <div className="vrLine"></div>
          </div>
          <div className="col-md-7">
            <NavLink
              className="btnWhiteGradient mt-4"
              to={`/AddLc-User-Modal?LearningManager_id=${LearningManager_id}`}
            >
              <i className="bi bi-envelope me-2 mt-3 h6"></i>{" "}
              {t("AddLearningCampaignUser")}
            </NavLink>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center mt-5">
          <div
            className="spinner-border loader-api"
            role="status"
            style={{
              borderTopColor: "#6897CB",
              borderBottomColor: "#6897CB",
              borderLeftColor: "#6897CB",
              marginTop: "50px",
            }}
          ></div>
        </div>
      ) : (
        <div className="bg-light px-3 py-3 userTableWrapper resTable">
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            <table className="table table-bordered table-hover">
              <thead className="thead-dark">
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {data.length > 0 && (
            <div className="button-container text-center mt-3">
              <button
                onClick={handleRemove}
                className="btn btn-danger"
                disabled={selectedIds.length === 0}
              >
                {t("RemoveSelected")}
              </button>
            </div>
          )}
        </div>
      )}

      {/* Pagination Controls using links.map */}
      <div className="navigationWrapper">
  <ul>
    {(Array.isArray(links) ? links : []).map((link, index) => (
      <li
        key={index}
        className={`${link.active ? " active " : ""} ${
          link.url === null ? " disabled " : ""
        }`}
        onClick={
          link.url !== null ? () => fetchLcUserModal(link.url) : undefined
        }
      >
        <div dangerouslySetInnerHTML={{ __html: link.label }} />
      </li>
    ))}
  </ul>
</div>

    </div>
  );
};

export default LcUserModal;

// import { Modal, Button } from "react-bootstrap";
// import React, { useEffect, useState } from 'react';
// import { api_url } from "../../constant/constant";
// import './Lcusermodal.css';
// import { useNavigate } from 'react-router-dom';
// import { useReactTable, getCoreRowModel, flexRender } from '@tanstack/react-table';
// import { useTranslation } from 'react-i18next';
// import { showToast } from "../ShowToast/ToastNotification";
// import { NavLink } from 'react-router-dom';

// const LcUserModal = ({ LearningManager_id }) => {

//     const navigate = useNavigate();
//     const { t } = useTranslation();
//     const [data, setLcUser] = useState([]);
//     const [links, setLinks] = useState({});
//     const [selectedIds, setSelectedIds] = useState([]);
//     const [searchValue, setSearchValue] = useState('');
//     const [loading, setLoading] = useState(false);

//     const handleCheckboxChange = (e, id) => {
//         const isChecked = e.target.checked;
//         if (isChecked) {
//             setSelectedIds((prevSelectedIds) => [...prevSelectedIds, id]);
//         } else {
//             setSelectedIds((prevSelectedIds) => prevSelectedIds.filter((selectedId) => selectedId !== id));
//         }
//     };

//     const handleAnswersClick = (id) => {
//         navigate(`/question/${id}`);
//     };

//     const handleRemove = async () => {
//         setLoading(true);
//         try {
//             const token = localStorage.getItem("userToken");

//             const response = await fetch(`${api_url}/learning-campaigns-users/${LearningManager_id}/detach-users`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`,
//                 },
//                 body: JSON.stringify({
//                     user_ids: selectedIds,
//                 }),
//             });

//             if (response.ok) {
//                 showToast(t("userDeletedSuccess"), "success");
//                 fetchLcUserModal(''); // Refresh the data
//             } else {
//                 showToast(t("userDeleteFailed"), "error");
//             }
//         } catch (error) {
//             showToast(t("somethingWentWrong"), "error");
//             setLoading(false);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (searchValue !== '') {
//             const filteredData = data.filter((item) =>
//                 item.email.toLowerCase().includes(searchValue.toLowerCase())
//                 || item.username.toLowerCase().includes(searchValue.toLowerCase())
//                 || item.firstname.toLowerCase().includes(searchValue.toLowerCase())
//                 || item.lastname.toLowerCase().includes(searchValue.toLowerCase())
//             );
//             setLcUser(filteredData);
//         } else {
//             fetchLcUserModal(''); // Fetch data on page load
//         }
//     }, [searchValue]);

//     const fetchLcUserModal = async (url) => {
//         setLoading(true);
//         let page = 1;
//         if (url) {
//             const temp = url.split("?page=");
//             page = temp[1] || 1;
//         }

//         try {
//             const token = localStorage.getItem("userToken");
//             const response = await fetch(url || `${api_url}/learning-campaigns-users/${LearningManager_id}/assigned-users?page=${page}`, {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${token}`,
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const result = await response.json();
//             setLcUser(result.data.data || []);
//             setLinks(result.data); // Store the links from the response
//         } catch (error) {
//             showToast(t("errorfetchingdata"), "error");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const columns = React.useMemo(
//         () => [
//             {
//                 accessorKey: 'email',
//                 header: () => (
//                     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                         <i className="bi bi-clipboard-data"></i>{t('Email')}
//                     </div>
//                 ),
//                 colName: t('Email'),
//             },
//             {
//                 accessorKey: 'username',
//                 header: () => (
//                     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                         <i className="bi bi-clipboard-data"></i>{t('UserName')}
//                     </div>
//                 ),
//                 colName: t('UserName'),
//             },
//             {
//                 accessorKey: 'firstname',
//                 header: () => (
//                     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                         <i className="bi bi-clipboard-data"></i>{t('FirstName')}
//                     </div>
//                 ),
//                 colName: t('FirstName'),
//             },
//             {
//                 accessorKey: 'lastname',
//                 header: () => (
//                     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                         <i className="bi bi-clipboard-data"></i>{t('LastName')}
//                     </div>
//                 ),
//                 colName: t('LastName'),
//             },
//             {
//                 accessorKey: 'id',
//                 header: () => (
//                     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                         <img src="/images/fi_alert-octagon.png" alt="Source" />{t('Action')}
//                     </div>
//                 ),
//                 cell: ({ getValue }) => {
//                     const id = getValue();
//                     return (
//                         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                             <input
//                                 type="checkbox"
//                                 onChange={(e) => handleCheckboxChange(e, id)}
//                             />
//                         </div>
//                     );
//                 },
//                 colName: t('Action'),
//             }
//         ],
//         []
//     );

//     const table = useReactTable({
//         data,
//         columns,
//         getCoreRowModel: getCoreRowModel(),
//     });

//     return (
//         <div className="p-4 mb-4">
//             {/* Search and Add User Section */}
//             <div className="primaryBlueBox mb-4" id="pa">
//                 <div className="row">
//                     <div className="col-md-4">
//                         <label className="form-label">{t('SearchUsers')}</label>
//                         <div className="input-group">
//                             <input type="text"
//                                 className="form-control"
//                                 placeholder={t("Searchbyname")}
//                                 aria-label="Search by name"
//                                 value={searchValue}
//                                 onChange={(e) => setSearchValue(e.target.value)} />
//                             <button className="btn btn-outline-secondary btnSearchIcon" type="button">
//                                 <i className="bi bi-search"></i>
//                             </button>
//                         </div>
//                     </div>
//                     <div className="col-md-7">
//                         <NavLink className="btnWhiteGradient mt-3" to={`/AddLc-User-Modal?LearningManager_id=${LearningManager_id}`}>
//                             <i className="bi bi-envelope me-2 mt-3 h6"></i> {t('AddLearningCampaignUser')}
//                         </NavLink>
//                     </div>
//                 </div>
//             </div>

//             {loading ? (
//                 <div className="d-flex justify-content-center align-items-center mt-5">
//                     <div className="spinner-border loader-api" role="status" style={{
//                         borderTopColor: "#6897CB",
//                         borderBottomColor: "#6897CB",
//                         borderLeftColor: "#6897CB",
//                         marginTop: "50px"
//                     }}></div>
//                 </div>
//             ) : (
//                 <div className="bg-light px-3 py-3 userTableWrapper resTable">
//                     <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
//                         <table className="table table-bordered table-hover">
//                             <thead className="thead-dark">
//                                 {table.getHeaderGroups().map(headerGroup => (
//                                     <tr key={headerGroup.id}>
//                                         {headerGroup.headers.map(header => (
//                                             <th key={header.id}>
//                                                 {flexRender(header.column.columnDef.header, header.getContext())}
//                                             </th>
//                                         ))}
//                                     </tr>
//                                 ))}
//                             </thead>
//                             <tbody>
//                                 {table.getRowModel().rows.map(row => (
//                                     <tr key={row.id}>
//                                         {row.getVisibleCells().map(cell => (
//                                             <td key={cell.id}>
//                                                 {flexRender(cell.column.columnDef.cell, cell.getContext())}
//                                             </td>
//                                         ))}
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                     {data.length > 0 && (
//                         <div className="button-container text-center mt-3">
//                             <button
//                                 onClick={handleRemove}
//                                 className="btn btn-danger"
//                                 disabled={selectedIds.length === 0}
//                             >
//                                 {t('RemoveSelected')}
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             )}

//             {/* Pagination Controls */}
//             <div className="navigationWrapper">
//                 <ul>
//                     {links?.links?.map((link, index) => (
//                         <li key={index}
//                             className={`${link.active ? " active " : ""} ${link.url === null ? " disabled " : ""}`}
//                             onClick={link.url !== null ? () => fetchLcUserModal(link.url) : undefined}
//                         >
//                             <div dangerouslySetInnerHTML={{ __html: link.label }} />
//                         </li>
//                     ))}
//                 </ul>
//             </div>
//         </div>
//     );
// };

// export default LcUserModal;
